import React, { Component } from 'react';
import { Flex } from 'core/components';
import Legend from 'app/components/dataviews/views/legend/Legend';

class JourneysDataView extends Component {
  resizeObserver = new ResizeObserver(() => {
    const { dataview } = this.props;
    dataview.reflow();
  });

  flexRef = React.createRef();

  componentDidMount() {
    this.resizeObserver.observe(this.flexRef.current);
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect();
  }

  render() {
    const {
      component,
      className,
      dataview,
      dataViewConfig,
      header,
      legendFlex,
      loading,
      minHeight,
      onQueryError,
      query
    } = this.props;

    if (!loading && dataview?.queryBuckets?.activeBucketCount > 0) {
      query.setDataviewCsv(dataview);
    }
    if (dataview?.errors.length > 0) {
      onQueryError(dataview.errors);
    }
    const { showLegend } = dataViewConfig;
    return (
      <>
        <Flex
          className={className}
          flexDirection="column"
          flex={1}
          ref={this.flexRef}
          // overflow="hidden"
          minHeight={minHeight}
        >
          <Flex flexDirection="column" p={1} px="12px">
            {header}
          </Flex>
          <Flex flex={1}>{component}</Flex>
        </Flex>
        {showLegend && (
          <Flex flex={legendFlex} m="1px">
            <Legend dataview={dataview} isVirtualized={false} includeTotalRow={false} />
          </Flex>
        )}
      </>
    );
  }
}

export default JourneysDataView;
